module.exports = __webpack_public_path__ + "img/Sidebar Toggle Left.2af6a4e9.svg";